import { render } from "./Own.vue?vue&type=template&id=6c1502c9"
import script from "./Own.vue?vue&type=script&lang=js"
export * from "./Own.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__